module.exports = __webpack_public_path__ + "static/media/3.2902c606.mp4";